// react
import React from 'react';
// components
import Loader from './loader';
// classnames
import cn from 'classnames/bind';
// assets
import styles from 'components/form/response-message/response.module.css';

const cx = cn.bind(styles);

interface IResponseMessage {
  isLoading: boolean;
  message: string;
  loadingMessage?: string;
  close?: () => void;
  iconName?:
    | 'subscribe'
    | 'subscribe-error'
    | 'send-message'
    | 'send-message-error'
    | 'subscribe-error-already-subscribed';
}

const ResponseMessage: React.FC<IResponseMessage> = ({
  isLoading,
  message,
  loadingMessage = `Please wait,\n message is being sent`,
  iconName = 'send-message',
  close,
}) => {
  if (!isLoading && !message) return null;

  return (
    <div className={styles.container}>
      <div className={cx('wrapper', { animation: !isLoading })}>
        <div className={styles.mediaSection}>
          {isLoading ? (
            <Loader />
          ) : (
            <div
              className={cx('img', {
                iconSendMessageSuccess: iconName === 'send-message',
                iconSubscribeSuccess: iconName === 'subscribe',
                iconError: iconName === 'subscribe-error' || iconName === 'send-message-error',
                iconSubscribeErrorAlreadySubscribed:
                  iconName === 'subscribe-error-already-subscribed',
              })}
            ></div>
          )}
        </div>
        <div className={styles.textSection}>
          <p>{isLoading ? loadingMessage : message}</p>
        </div>
        {isLoading ? null : <button className={styles.closeBtn} onClick={close} />}
      </div>
    </div>
  );
};

export default ResponseMessage;
